<template>
    <fragment>
        <InsideHeader :title="pageData.title" :bredcrumb="breadcrumb" />
        <About :pagedata="pageData" :filepath="filePath" />       
        <Features/>
    </fragment>
</template>

<script>
import InsideHeader from "../components/InsideHeader.vue";
import About from "../components/About/About.vue";
import Features from "../components/About/Features.vue";
export default {
    components: {
        InsideHeader, About, Features
    },
    data(){
        return {
            breadcrumb: [
                {title: 'Home', path:'/'},
                {title: 'About Us', path:'#'}
            ],
            filePath: '',
            pageData: {}
        }
    },
    methods: {
        getData(){            
            this.$http.get(`/about-us`).then(res=>{                       
                if(res.status === 200 && res.data){
                    if(res.data.page_data)
                        this.pageData = res.data.page_data
                    if(res.data.page_file_path)
                        this.filePath = res.data.page_file_path
                }
            })
        }
    },
    created: function(){
        this.getData()
    }
}
</script>